import { connect } from 'react-redux'
import toJS from '../general/toJS'
import PageMatchReportPage from '../../components/PageMatchReport/present/PageMatchReportPage'
import getData from '../../functions/getData'
import actionTypes from '../../actions/actionTypes'
import {
    PROGRAM_MATCH_CANDIDATES,
    PREVIEW_MOVIES_ITEMS,
    PROGRAM_CINEMAS,
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_PY_MOVIES_ITEMS,
    PROGRAM_KH_MOVIES_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
    PROGRAM_MARSX_MOVIES_ITEMS,
    PROGRAM_VISTA_MOVIES_ITEMS,
} from '../../constants/state'

const mapStateToProps = state => ({
    candidates:     getData(state, [PROGRAM_MATCH_CANDIDATES, 'list']),
    items:          getData(state, PREVIEW_MOVIES_ITEMS),
    cinemas:        getData(state, PROGRAM_CINEMAS),
    movieMappings:  getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    pyMovies:       getData(state, PROGRAM_PY_MOVIES_ITEMS),
    khMovies:       getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compesoMovies:  getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    dieselMovies:   getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    cortecMovies:   getData(state, PROGRAM_CORTEC_MOVIES_ITEMS),
    marsxMovies:    getData(state, PROGRAM_MARSX_MOVIES_ITEMS),
    vistaMovies:    getData(state, PROGRAM_VISTA_MOVIES_ITEMS),
})

const mapDispatchToProps = dispatch => ({
    onMerge: (sourceMetaMoviePk, destinationMetaMoviePk) => dispatch({
        type: actionTypes.META_MERGE_REQUEST,
        payload: { sourceMetaMoviePk, destinationMetaMoviePk },
    }),
})

const PageMatchReportContainer = props => <PageMatchReportPage {...props} />

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PageMatchReportContainer))
